"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const uuid_1 = require("uuid");
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function WarningOctagonSmallSvg(props) {
    const id0 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    const id1 = (0, react_1.useMemo)(() => (0, uuid_1.v4)(), []);
    return react_1.default.createElement("svg", Object.assign({ width: "32px", height: "32px", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("polygon", { id: `warningoctagonsmall-${id0}`, points: "4.33333333 0 11.6666667 0 16 4.33333333 16 11.6666667 12 16 4 16 0 11.6666667 0 4.33333333" }),
            react_1.default.createElement("filter", { x: "-75.0%", y: "-62.5%", width: "250.0%", height: "250.0%", filterUnits: "objectBoundingBox", id: `warningoctagonsmall-${id1}` },
                react_1.default.createElement("feMorphology", { radius: 2, operator: "dilate", in: "SourceAlpha", result: "shadowSpreadOuter1" }),
                react_1.default.createElement("feOffset", { dx: 0, dy: 2, in: "shadowSpreadOuter1", result: "shadowOffsetOuter1" }),
                react_1.default.createElement("feGaussianBlur", { stdDeviation: 3, in: "shadowOffsetOuter1", result: "shadowBlurOuter1" }),
                react_1.default.createElement("feComposite", { in: "shadowBlurOuter1", in2: "SourceAlpha", operator: "out", result: "shadowBlurOuter1" }),
                react_1.default.createElement("feColorMatrix", { values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0", type: "matrix", in: "shadowBlurOuter1" }))),
        react_1.default.createElement("g", { id: "Questions", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("g", { id: "Questionnaire-Builder--Questions-Warning-(move-to-share)", transform: "translate(-1037.000000, -136.000000)" },
                react_1.default.createElement("g", { id: "Group-21", transform: "translate(1045.000000, 142.000000)" },
                    react_1.default.createElement("g", { id: "Rectangle" },
                        react_1.default.createElement("use", { fill: "black", fillOpacity: 1, filter: `url(#warningoctagonsmall-${id1})`, xlinkHref: `#warningoctagonsmall-${id0}` }),
                        react_1.default.createElement("path", { stroke: "#FFFFFF", strokeWidth: 2, d: "M12.0808802,-1 L17,3.91911977 L17,12.0576505 L12.4378312,17 L3.56216877,17 L-1,12.0576505 L-1,3.91911977 L3.91911977,-1 L12.0808802,-1 Z", fill: "#FF6161", fillRule: "evenodd" })),
                    react_1.default.createElement("g", { id: "Group-2", transform: "translate(7.000000, 3.000000)", fill: "#FFFFFF" },
                        react_1.default.createElement("rect", { id: "Rectangle", x: 0, y: 0, width: 2, height: 6 }),
                        react_1.default.createElement("rect", { id: "Rectangle", x: 0, y: 8, width: 2, height: 2 }))))));
}
function WarningOctagonSmall(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(WarningOctagonSmallSvg, Object.assign({}, svgProps)));
}
exports.default = WarningOctagonSmall;
//# sourceMappingURL=WarningOctagonSmall.js.map